module.exports = __webpack_public_path__ + "img/UTBEAR-1.00ab345e.jpg";